import type {
  TransferCardDoneDeal,
  TransferCardDoneDealSwap,
  TransferCardRenewal,
  TransferCardRumor,
  TransferCardRumorRenewal,
  TransferCardRumorSwap,
  TransferLikelihood,
} from "@motain/xpa-proto-files-web/lib/types/transfers";
import { isNullable } from "@/types/isNullable";

const ARROW_RIGHT_GREEN_URL = {
  dark: "https://images.onefootball.com/cw/icons/arrow-right-green-dark.svg",
  light: "https://images.onefootball.com/cw/icons/arrow-right-green-light.svg",
};

const DOUBLE_ARROW_GREEN_URL = {
  dark: "https://images.onefootball.com/cw/icons/double-arrow-green-dark.svg",
  light: "https://images.onefootball.com/cw/icons/double-arrow-green-light.svg",
};

const ARROW_RIGHT_GRAY_URL = {
  dark: "https://images.onefootball.com/cw/icons/media-play-magenta-dark.svg",
  light: "https://images.onefootball.com/cw/icons/arrow-right-gray-light.svg",
};

const DOUBLE_ARROW_GRAY_URL = {
  dark: "https://images.onefootball.com/cw/icons/double-arrow-gray-dark.svg",
  light: "https://images.onefootball.com/cw/icons/double-arrow-gray-light.svg",
};

type stateType =
  | {
      $case: "transferCardDoneDeal";
      transferCardDoneDeal: TransferCardDoneDeal;
    }
  | {
      $case: "transferCardDoneDealSwap";
      transferCardDoneDealSwap: TransferCardDoneDealSwap;
    }
  | {
      $case: "transferCardRenewal";
      transferCardRenewal: TransferCardRenewal;
    }
  | {
      $case: "transferCardRumor";
      transferCardRumor: TransferCardRumor;
    }
  | {
      $case: "transferCardRumorSwap";
      transferCardRumorSwap: TransferCardRumorSwap;
    }
  | {
      $case: "transferCardRumorRenewal";
      transferCardRumorRenewal: TransferCardRumorRenewal;
    };

type transferStatePipeType =
  | {
      image?: {
        dark: string;
        light: string;
      };
      footerText: string;
      message?: string;
      likelihood?: TransferLikelihood;
    }
  | undefined;

export const transferStatePipe = (
  state: stateType | undefined,
): transferStatePipeType => {
  if (isNullable(state)) {
    return undefined;
  }

  switch (state.$case) {
    case "transferCardDoneDeal":
      return {
        image: ARROW_RIGHT_GREEN_URL,
        footerText: state.transferCardDoneDeal.footerText,
      };
    case "transferCardDoneDealSwap":
      return {
        image: DOUBLE_ARROW_GREEN_URL,
        footerText: state.transferCardDoneDealSwap.footerText,
      };
    case "transferCardRenewal":
      return {
        image: undefined,
        footerText: state.transferCardRenewal.footerText,
        message: state.transferCardRenewal.renewalPeriod,
      };
    case "transferCardRumor":
      return {
        image: ARROW_RIGHT_GRAY_URL,
        footerText: state.transferCardRumor.footerText,
        likelihood: state.transferCardRumor.likelihood,
      };
    case "transferCardRumorSwap":
      return {
        image: DOUBLE_ARROW_GRAY_URL,
        footerText: state.transferCardRumorSwap.footerText,
        likelihood: state.transferCardRumorSwap.likelihood,
      };
    case "transferCardRumorRenewal":
      return {
        image: undefined,
        footerText: state.transferCardRumorRenewal.footerText,
        likelihood: state.transferCardRumorRenewal.likelihood,
      };
    default:
      return undefined;
  }
};
